<template>
  <div>
    <page-main
      :tableData="tableData"
      :loading="loading"
      :disabled="disabled"
      :sourceType="sourceType"
      @reload="reload"
      @batchDel="submitDel"
    >
      <page-header
        ref="header"
        slot="header"
        :disabled="disabled"
        :shipmentCode="shipmentCode"
        @query="getData"
        @onClickPrint="onClickPrint"
      />
    </page-main>
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="errDialogVisible"
      width="30%"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      destroy-on-close
    >
      <span style="display:block;text-align:center;font-size:16px"
        >未查询到数据，页面将在
        <span style="font-size:22px;color:#409EFF">{{ sencond }}</span>
        秒后关闭</span
      >
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeCurPage()" type="primary" size="small">{{
          '立即关闭'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
import { mapActions } from 'vuex'
export default {
  components: { PageHeader, PageMain },
  mixins: [BaseTable, EditLoading],
  props: {
    shipmentCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    sourceType: { type: String, default: '' },
  },
  data() {
    return {
      errDialogVisible: false, //控制弹出
      sencond: 3, //设置初始倒计时
    }
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    getData(form) {
      this.loading = true
      this.$api
        .shipmentBatchListApi({
          shipmentCode: this.shipmentCode,
          ...form,
        })
        .then((res) => {
          this.loading = false
          if (res.status === 203) {
            this.getsencond()
          }
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    getsencond() {
      if (this.errDialogVisible) return
      this.errDialogVisible = true
      let clock = setInterval(() => {
        this.sencond--
        if (this.sencond === 0) {
          clearInterval(clock)
          this.sencond = 3
          if (this.errDialogVisible) {
            this.closeCurPage()
          }
        }
      }, 1000)
    },
    async closeCurPage() {
      this.errDialogVisible = false
      // 关闭当前页面
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
    submitDel(listCode) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.$api.shipmentContainerDelApi({ listCode }).then(() => {
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
            type: 'success',
          })
          this.$refs.tableHeader.query()
        })
      })
    },
    onClickPrint() {
      // 调用批次导出接口，确认是否有对应数据
      this.loadingOpen()
      this.$api
        .shipmentExportCheckDataApi({
          shipmentCode: this.shipmentCode,
        })
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status === 200) {
            // 通过数据检查，增加下载任务
            this.addExportTask(`factory-shipment`)
          }
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    addExportTask(taskName) {
      const context = {
        shipmentCode: this.shipmentCode,
        type: 'batch',
      }
      this.loadingOpen()
      this.$api
        .SYS_EXPORT_TASK(taskName, context)
        .then((res) => {
          this.loadingClose()
          const { status } = res || {}
          if (200 === status) {
            this.$message({
              message:
                this.$l('INDEX.added_to_the_download_center') ||
                '导出任务已经添加到下载中心，请稍后从下载中心下载文件',
              type: 'success',
            })
            return
          } else {
            this.$message.error(
              this.$l('INDEX.Description_Failed_to_add_export_task') ||
                '导出任务添加失败'
            )
          }
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(
            this.$l('INDEX.Description_Failed_to_add_export_task') ||
              '导出任务添加失败'
          )
        })
    },
  },
}
</script>
